import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { MdDashboard } from 'react-icons/md';
import { FaDownload, FaCalendarAlt, FaSignOutAlt, FaUserCircle, FaBars, FaDraftingCompass } from 'react-icons/fa';
import logo from '../asserts/img/logo.png';
import './Layout.css';

const Layout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    sessionStorage.clear();
    navigate('/signin');
  };

  const toggleSidebar = () => {
    if (window.innerWidth < 992) {
      setSidebarOpen((prev) => !prev);
    } else {
      setSidebarCollapsed((prev) => !prev);
    }
  };

  const menuItems = [
    {
      title: 'Dashboard',
      path: '/dashboard',
      icon: <MdDashboard />,
      badge: null
    },
    {
      title: 'Download Catalog',
      path: '/catalog-enquiries',
      icon: <FaDownload />,
      badge: null
    },
    {
      title: 'Enquiry List',
      path: '/consultant-enquiries',
      icon: <FaCalendarAlt />,
      badge: null
    },
    {
      title: 'Architecture Enquiries',
      path: '/architecture-enquiries',
      icon: <FaDraftingCompass />,
      badge: null
    }
  ];

  return (
    <div id="wrapper">
      {/* Mobile Backdrop */}
      {sidebarOpen && (
        <button type="button" aria-label="Close Sidebar" className="sidebar-backdrop" onClick={() => setSidebarOpen(false)} />
      )}

      {/* Sidebar */}
      <aside className={`premium-sidebar ${sidebarOpen ? 'show-mobile' : ''} ${sidebarCollapsed ? 'collapsed' : ''}`}>
        {/* Brand Header with Logo */}
        <Link to="/dashboard" className="sidebar-brand">
          <img src={logo} alt="ARISTO" className="sidebar-brand-logo" />
        </Link>

        {/* Sidebar Nav */}
        <div className="sidebar-heading">Main Menu</div>
        <nav className="nav-menu">
          {menuItems.map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`nav-item-link ${isActive ? 'active' : ''}`}
                onClick={() => setSidebarOpen(false)}
              >
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  {item.icon}
                  <span>{item.title}</span>
                </div>
                {item.badge && <span className="nav-badge">{item.badge}</span>}
              </Link>
            );
          })}
        </nav>

        {/* Sidebar Footer */}
        <div className="sidebar-footer">
          <div className="profile-card">
            <FaUserCircle size={32} color="#c4a882" />
            <div style={{ overflow: 'hidden' }}>
              <div style={{ fontSize: '13px', fontWeight: 700, color: '#fff', whiteSpace: 'nowrap' }}>Aristo Enquiry Admin</div>
            </div>
          </div>
          <button onClick={handleLogout} className="logout-btn">
            <FaSignOutAlt size={12} /> Logout
          </button>
        </div>
      </aside>

      {/* Main Content Area */}
      <div className={`main-wrapper ${sidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
        {/* Top Header */}
        <header className="top-header">
          <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
            <button
              type="button"
              onClick={toggleSidebar}
              className="sidebar-toggle-btn"
              title={sidebarCollapsed ? 'Open Sidebar' : 'Close Sidebar'}
            >
              <FaBars size={17} />
            </button>
            <span style={{ fontSize: '13px', color: '#8a8377', fontWeight: 500, letterSpacing: '0.5px' }}>
              ARISTO &bull; <strong style={{ color: '#c4a882' }}>Enquiry Management Dashboard</strong>
            </span>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <Link to="/catalog-enquiries" className="btn-gold-outline" style={{ fontSize: '11px' }}>
              <FaDownload size={11} /> Download Catalog
            </Link>
            <Link to="/consultant-enquiries" className="btn-gold" style={{ fontSize: '11px' }}>
              <FaCalendarAlt size={11} /> Enquiry List
            </Link>
          </div>
        </header>

        {/* Page Content */}
        <main style={{ flex: 1, padding: '1.5rem 1.75rem', minWidth: 0, boxSizing: 'border-box', width: '100%', maxWidth: '100%' }}>
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;
